import { MANIFESTO } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";

export default function Manifesto() {
  return (
    <section className="relative section-pad overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="overline mb-4">Manifesto</div>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-[-0.02em] leading-[0.95]">
              We don't just build websites.<br />
              <span className="italic text-gradient">We build digital businesses.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.06}>
              <div className="flex gap-6">
                <div className="chapter-num shrink-0">{m.n}</div>
                <div className="pt-2">
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight mb-3">{m.title}</h3>
                  <p className="text-[15px] leading-relaxed text-[color:var(--text-muted)] max-w-[440px]">{m.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
